import React from 'react';
import Icon from '@common/assets';
import Text from '@common/text';
import styles from '@components/profile/profileOverlay/overlays/career/career.module.scss';
import Colors from '@domain/constant/colors';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface TipProps {
  type: 'required' | 'verified';
}

const Tip = ({ type }: TipProps) => {
  switch (type) {
    case 'verified':
      return (
        <div className={cx('verifiedTipArea')}>
          <div className={cx('iconArea')}>
            <Icon name={'verifiedLightFilled'} width={24} height={24} fill={Colors.C_GREEN_150} />
            <div className={cx('tooltipArea')}>
              <Text fontStyle={FontStyle.B3_B} color={Colors.C_WHITE}>
                불러온 경력 정보
              </Text>
              <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_30}>
                불러온 경력 정보의 직장명, 상태, 근무 기간은 인증된 정보라서 수정할 수 없어요. 업데이트가 필요하다면
                다시 경력을 불러와 주세요.
              </Text>
            </div>
          </div>
          <Text fontStyle={FontStyle.B4_M} color={Colors.C_COOL_GRAY_70}>
            불러온 경력 정보는 수정할 수 없어요.
          </Text>
        </div>
      );
    case 'required':
    default:
      return null;
  }
};

export default Tip;
